// Coleções
(function () {
  'use strict';

  if ($('#modal-emails-automatizados').length > 0) {
    const $emailsList = $('#emails_list');
    const $tableEmails = $emailsList.find('table');
    const $modalEmails = $('#modal-emails-automatizados');
    const $modalEmailsCad = $('#modal-emails-automatizados-cadastro');
    const $btnCadastro = $('#btn-email-cadastro');
    const $formCadastro = $('#form-envios-digitais-cadastro');
    const $selectProduto = $('#produto_email');
    const $inputAssunto = $('input#email_assunto');
    const $tipoArquivo = $('.tipo_arquivo');
    $.fn.modal.Constructor.prototype._enforceFocus = function () {};
    var urlAppsBase = $emailsList.data('url');
    var buscando = false;
    $emailsList.data('pagina', 1);
    $emailsList.data('emails_buscados', false);
    $emailsList.data('ultimo_timestamp', new Date().getTime());
    const textoLista = {
      empty: 'Nenhuma mensagem cadastrada.',
      texto_cadastro: `<p>Ol&aacute;, {{user_name}}!</p>\n\n<p>Segue o acesso para o produto digital, referente ao seu pedido <b>{{order_id}}</b></p>\n\n<p>Obrigado!</p>`,
    };
    const htmlLinha = (item) => `
    <tr data-row="${item['id']}">
      <td data-label="Produto">
        <a href="#" class="d-flex align-items-center link-dark">
          <img src="${item['image_main_small']}" class="img-fluid rounded mr-2" width="50px">
          <b>${item['title']}</b>
        </a>
      </td>
      <td>
      <div class="table-options">
        <a href="#" class="btn btn-sm btn-default email-edit" data-toggle="tooltip" data-placement="bottom" title="Editar" data-form-action="update" data-registro="${item['id']}" data-img="${item['image_main_small']}" data-titulo="${item['title']}" data-url="${urlAppsBase}"><i class="las la-pen"></i></a>
        <a href="#" class="btn btn-sm btn-danger" data-toggle="tooltip" data-placement="bottom" title="Remover" data-action="remove_unico" data-value="${item['id']}"><i class="las la-trash"></i></a>
      </div>
      </td>
    </tr>
    `;
    const htmlLinhaLoad = () => `
    <tr class="linha_buscando">
      <td colspan="2" class="p-0">
        <div class="loader-el-wrp active" style="min-height: 100px !important;">
          <div class="loader-container">
            <div class="loader-wrapper">
              <div class="loader"></div>
            </div>
          </div>
        </div>
      </td>
    </tr>`;
    const htmlLinhaSelectProduto = (produto) => {
      const itemOpt = new Option(produto.title, produto.id, true, true);
      itemOpt.image = produto.image_main_small;
      return itemOpt;
      /*  `
      <option value="${produto.id}" data-image="${produto['image_main_small']}">${produto['title']}</option>
    `; */
    };
    function addProdutosTable(result) {
      if (result.total > 0) {
        result['produtos'].forEach(function (item) {
          $tableEmails.find('tbody').append(htmlLinha(item));
        });
      } else {
        $tableEmails.find('tbody').html(`
        <tr>
          <td colspan="2">
          ${textoLista['empty']}
          </td>
        </tr>`);
      }
    }

    // Habilita tipo de arquivo
    function checkTipoArquivo() {
      const $tipoSelecionado = $('input.tipo_arquivo:checked');
      const $tiposArquivos = $('.tipos_arquivo');
      $tiposArquivos.show();
      $tiposArquivos.find('[data-tipo]').hide();
      $tiposArquivos.find(`[data-tipo="${$tipoSelecionado.val()}"]`).show();
    }
    checkTipoArquivo();

    // Abre o modal após executar alguma ação de remoção ou cadastro
    function formularioCarregado() {
      // Se executou ação de form -> abre o formulário
      if (localStorage.getItem('envios_digitais_acao')) {
        var tempo_execucao = localStorage.getItem('envios_digitais_acao');
        try {
          tempo_execucao = JSON.parse(tempo_execucao);
          tempo_execucao = tempo_execucao.time;
          var tempo_atual = new Date().getTime();
          var intervalo_tempo = (tempo_atual - tempo_execucao) / 1000;

          if (intervalo_tempo < 10) {
            $modalEmails.modal('show');
          }
        } catch (e) {
          console.log(e);
        }

        localStorage.removeItem('envios_digitais_acao');
      }
    }
    formularioCarregado();

    // Verifica se já passou 2 segundos antes de iniciar outra busca
    function podeBuscar() {
      var timestampAtual = new Date().getTime();
      var ultimoTimestamp = $emailsList.data('ultimo_timestamp');
      var tempo_passado = Math.round((timestampAtual - ultimoTimestamp) / 1000);
      var tempo_espera = 1; // 2 segundos

      if (tempo_passado < tempo_espera) {
        return false;
      } else {
        $emailsList.data('ultimo_timestamp', new Date().getTime());
        return true;
      }
    }

    async function beforeBuscaProdutos() {
      $tableEmails.find('tbody').append(htmlLinhaLoad());
    }

    function buscaProdutos(pagina = 1, before_busca = true) {
      if (before_busca) {
        beforeBuscaProdutos();
      }
      const url = $emailsList.data('url');
      buscando = true;
      const data = {
        acao: 'busca_produtos',
        p: pagina,
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }

    function buscaProdutosCadastro() {
      const url = $emailsList.data('url');
      const data = {
        acao: 'busca_produtos_cadastro',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }

    function buscaRegistro(obj) {
      const url = obj.url;
      const data = {
        acao: 'email_busca_registro',
        id_update: obj.id_update,
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }

    $tipoArquivo.on('change', tipoArquivoChange);
    function tipoArquivoChange(e) {
      // Arquivo mudou!
      const tipo_arquivo = $(this).val();
      const $campoExibe = $(`[data-tipo="${tipo_arquivo}"]`);
      const $tiposArquivoContainer = $('.tipos_arquivo');

      $tiposArquivoContainer.show();
      $tiposArquivoContainer.find('[data-tipo]').hide();
      $campoExibe.show();
      // console.log('tipo_escolhido ' + tipo_arquivo);
    }

    // Abrir modal para editar
    $emailsList.on('click', '.email-edit', modalEmailEdit);
    function modalEmailEdit(ev) {
      showLoader();
      $modalEmails.modal('hide');
      atualizaAcaoModalCadastro('email_edit');

      var $el = $(ev.target);
      if (!$el.hasClass('email-edit')) {
        $el = $el.closest('.email-edit');
      }
      var id_update = $el.data('registro');
      var url = $el.data('url');
      var img = $el.data('img');
      var title = $el.data('titulo');

      var obj = {
        id_update: id_update,
        url: url,
      };
      resetModalCadastro();
      ocultaSelect();

      // Busca mensagem
      buscaRegistro(obj)
        .done((registro) => {
          $modalEmailsCad.modal('show');
          if (registro.status == 'success') {
            $selectProduto.append(htmlLinhaSelectProduto({ id: registro.registro.produto_id }));
            populaModalEdit(registro.registro);
            exibeImgProduto({ img: img, title: title });
          } else {
            // console.log(registro);
          }
        })
        .always(() => hideLoader());

      // htmlLinhaSelectProduto
    }

    // Executou remoção
    $(document).on('remove', (ev, table) => {
      const $table = $(table);
      if ($table.data('form-mult') == '#form-multiplos-email') {
        executouAcaoForm();
      }
    });

    $formCadastro.on('submit', formCadastroSubmit);
    function formCadastroSubmit(ev) {
      executouAcaoForm();
    }

    // Executou alguma formação de deletar ou cadastrar
    function executouAcaoForm() {
      localStorage.setItem(
        'envios_digitais_acao',
        JSON.stringify({
          time: new Date().getTime(),
        }),
      );
    }

    function populaModalEdit(dados) {
      $inputAssunto.val(dados.assunto ? dados.assunto : '');
      var textArea = CKEDITOR.instances.description;
      textArea.setData(dados.mensagem);
      $selectProduto.val(dados.produto_id).trigger('change');
      $modalEmailsCad.find('input[name="id_update"]').val(dados.produto_id);
      $(
        `#form-envios-digitais-cadastro input[name="tipo_arquivo"][value="${
          dados.tipo_arquivo != null ? dados.tipo_arquivo : 'link'
        }"]`,
      ).click();
      $(`#form-envios-digitais-cadastro input[name="link"]`).val(dados.link);
    }

    // Botão cadastro
    $btnCadastro.on('click', btnCadastroClick);
    function btnCadastroClick(ev) {
      $modalEmailsCad.trigger('email-cadastro');
    }

    // Inicia busca pelos produtos
    $('#modal-emails-automatizados').on('shown.bs.modal', function () {
      if ($emailsList.data('emails_buscados') == false) {
        var pagina = getPagina();
        buscaProdutos(pagina).done(addProdutosTable).always(afterBuscaProdutos);
      }
    });
    $modalEmailsCad.on('email-cadastro', modalEmailCadastro);
    function modalEmailCadastro(ev) {
      showLoader();
      $modalEmails.modal('hide');

      exibeSelect();
      atualizaAcaoModalCadastro('email_cadastro');

      limparSelect();
      buscaProdutosCadastro()
        .done((result) => {
          result.produtos.forEach((produto) => {
            $selectProduto.append(htmlLinhaSelectProduto(produto));
          });
        })
        .fail(console.log)
        .always(() => {
          resetModalCadastro();
          hideLoader();
          $modalEmailsCad.modal('show');
        });
    }

    function resetModalCadastro() {
      $selectProduto.val('').trigger('change');
      var textArea = CKEDITOR.instances.description;
      // textArea.setData('');
      $formCadastro.find('input[name="tipo_arquivo"][value="link"]').click();
      $formCadastro.find('input[name="link"]').val('');
      $formCadastro.find('input[name="arquivo"]').val('');
      $formCadastro.find('input[name="assunto"]').val('');
      textArea.setData(textoLista['texto_cadastro']);
      $selectProduto.closest('form').parsley().reset();
      $('.produto-img').hide();
    }

    function limparSelect() {
      $selectProduto.find('option:nth-child(n + 2)')?.remove();
    }

    $modalEmailsCad.on('hide.bs.modal', modalEmailCadHide);
    function modalEmailCadHide() {
      $modalEmails.modal('show');
    }

    $modalEmails.on('hide.bs.modal', modalEmailHide);
    function modalEmailHide() {
      if (localStorage.getItem('envios_digitais_aberto')) {
        localStorage.remove('envios_digitais_aberto');
      }
    }

    function atualizaAcaoModalCadastro(acao) {
      $modalEmailsCad.find('input[name="acao"]').val(acao);
    }

    function afterBuscaProdutos(registro) {
      var pagina = $emailsList.data('pagina');
      $emailsList.data('pagina', pagina + 1);
      $emailsList.find('table').find('.linha_buscando')?.remove();
      buscando = false;

      if (registro.registros > registro.total) {
        $emailsList.data('emails_buscados', true);
      }
    }

    // Recarrega items conforme scroll
    $emailsList.on('scroll', eventScroll);
    function eventScroll(e) {
      var distanciaBottom = $(this)[0].scrollHeight - ($(this).scrollTop() + $(this).height());

      if (distanciaBottom < 150 && $(this).data('emails_buscados') == false) {
        if (podeBuscar() && buscando == false) {
          var pagina = getPagina();
          buscaProdutos(pagina)
            .done((result) => {
              if (result.total > 0) {
                addProdutosTable(result);
              } else {
                $(this).data('emails_buscados', true);
              }
            })
            .always(afterBuscaProdutos);
        }
      }
    }

    function getPagina() {
      return $emailsList.data('pagina');
    }

    function exibeImgProduto({ img, title }) {
      $('.produto-img').show();
      $('.produto-img img').attr('src', img);
      $('.produto-img-title').text(title);
    }

    function ocultaSelect() {
      $selectProduto.next().hide();
      $('label[for="produto_email"]').hide();
    }

    function exibeSelect() {
      $selectProduto.next().show();
      $('label[for="produto_email"]').show();
    }
  }
})();
